import Intercom, {
  shutdown as intercomShutdown,
} from "@intercom/messenger-js-sdk";
import { THEME } from "../consts/theme";

export class IntercomService {
  #color = THEME.colors.primary;
  #isBooted = false;
  #bootKey = "";

  /**
   * @param {{
   *   boot: Function
   *   shutdown: Function
   * }} repo
   */
  constructor(repo) {
    this.repo = repo;
  }

  boot(arg = {}) {
    const appId = arg.app_id;
    const userId = arg.user_id || "guest";

    if (!appId) {
      return;
    }

    const nextBootKey = `${appId}:${userId}`;

    if (this.#isBooted && this.#bootKey === nextBootKey) {
      return;
    }

    if (this.#isBooted && this.#bootKey !== nextBootKey) {
      this.repo.shutdown();
      this.#isBooted = false;
      this.#bootKey = "";
    }

    const payload = {
      ...arg,
      action_color: this.#color,
    };

    this.repo.boot(payload);
    this.#isBooted = true;
    this.#bootKey = nextBootKey;
  }

  shutdown() {
    if (!this.#isBooted) {
      return;
    }

    this.repo.shutdown();
    this.#isBooted = false;
    this.#bootKey = "";
  }
}

export const intercomService = new IntercomService({
  boot: Intercom,
  shutdown: intercomShutdown,
});
